import { Navigate, Outlet } from "react-router-dom";
import { useQuery } from "@project/ui";
import { useI18n } from "@apps/dashboard/contexts/I18nContext";
import {
  fetchAccountOnboarding,
  homeExpenseQueryKeys,
} from "@apps/dashboard/lib/home-expense-api";
import { dashboardPaths } from "@apps/dashboard/lib/routes";
import { LoadingState } from "@apps/dashboard/components/states/LoadingState";
import { ErrorState } from "@apps/dashboard/components/states/ErrorState";

export function OnboardingGate(): JSX.Element {
  const { locale } = useI18n();
  const q = useQuery({
    queryKey: homeExpenseQueryKeys.accountOnboarding(locale),
    queryFn: () => fetchAccountOnboarding(locale),
  });

  if (q.isPending) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface">
        <LoadingState />
      </div>
    );
  }

  if (q.isError) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface p-6">
        <ErrorState onRetry={() => void q.refetch()} />
      </div>
    );
  }

  if (!q.data?.onboardingCompletedAt) {
    return <Navigate to={dashboardPaths.onboarding} replace />;
  }

  return <Outlet />;
}
